import { C_ACTION } from '../constans';

export const addUser = user => ({
  type: C_ACTION.ADD_USER,
  user,
});

export const removeUser = () => ({
  type: C_ACTION.REMOVE_USER,
});

export const changeUser = user => ({
  type: C_ACTION.CHANGE_USER,
  user,
});
